module.exports = __webpack_public_path__ + "img/4.9bd741b3.png";